export default function Hero() {
  const stats = [
    { value: "2.8亿+", label: "累计注册用户" },
    { value: "120万+", label: "在线常驻频道" },
    { value: "380万", label: "日峰值在线" },
    { value: "98.6%", label: "用户满意度" },
  ];

  return (
    <section id="home" className="relative flex min-h-screen items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20glowing%20audio%20sound%20waveform%20visualization%20with%20flowing%20ribbons%20of%20warm%20amber%20orange%20and%20fresh%20mint%20green%20light%20glowing%20on%20deep%20dark%20charcoal%20green%20background%2C%20futuristic%20digital%20voice%20communication%20technology%20concept%2C%20elegant%20energy%20particles%20and%20bokeh%2C%20cinematic%20atmosphere%2C%20high%20detail%20artistic%20digital%20art&width=1600&height=900&seq=yy-hero-1&orientation=landscape"
          alt="歪歪语音高清连麦与互动直播的背景光效"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/70 to-background-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-transparent to-background-950/60"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 pt-28 pb-16 md:pt-36 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3 py-1 text-xs font-medium text-primary-300">
            <i className="ri-wifi-line" aria-hidden="true"></i>
            高清连麦 · 畅玩开黑 · 多彩直播
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-foreground-50">
            听见世界，<br className="md:hidden" />
            <span className="text-primary-400">遇见每一段热爱</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-foreground-200">
            歪歪语音聚合高清语音连麦、在线开黑与互动直播，全新客户端带你畅享多彩频道的每一次连接。下载官方客户端，开通会员权益，随时随地与好友畅快开麦。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-950 hover:bg-primary-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-download-2-line text-lg" aria-hidden="true"></i>
              立即下载客户端
            </a>
            <a
              href="#features"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300/70 bg-background-100/60 px-7 py-3.5 text-base font-medium text-foreground-100 hover:border-primary-400/60 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg" aria-hidden="true"></i>
              在线使用网页版
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-xl border border-background-200/70 bg-background-950/50 p-4 backdrop-blur-sm"
              >
                <dt className="order-2 mt-1 block text-xs text-foreground-400">{item.label}</dt>
                <dd className="order-1 block font-heading text-2xl md:text-3xl text-primary-400">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <a
        href="#features"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full border border-background-300/70 text-foreground-300 hover:text-primary-400 hover:border-primary-400/60 transition-colors"
        aria-label="向下滚动查看更多"
      >
        <i className="ri-arrow-down-line" aria-hidden="true"></i>
      </a>
    </section>
  );
}